import { createAction } from 'redux-actions'

import {
  GET_LEDGER_FILTERS,
  GET_LEDGER_FILTERS_FAILED,
  GET_LEDGER_FILTERS_SUCCEEDED,
  RESET_LEDGER_FILTERS,
} from 'Redux/Types/LedgerFilterTypes'

export const getLedgerFilters = createAction(GET_LEDGER_FILTERS)
export const getLedgerFiltersFailed = createAction(GET_LEDGER_FILTERS_FAILED)
export const getLedgerFiltersSucceeded = createAction(GET_LEDGER_FILTERS_SUCCEEDED)

export const resetLedgerFilters = createAction(RESET_LEDGER_FILTERS)
